// extracted by mini-css-extract-plugin
export default {"heroHeader":"ParkAvenue_heroHeader__qBmut","adj1":"ParkAvenue_adj1__QJZsS","adj2":"ParkAvenue_adj2__Ikhpr","adj3":"ParkAvenue_adj3__apmFz"};